//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from '~/components/SearchBox';
import WhoApp from '~/components/lp_whoapp/Index';
import LoadingData from '~/components/LoadingData';
import Testimonial from '~/components/Testimonial';
import WhoTestimonial from '~/components/WhoTestimonial';
import WhoPayment from '~/components/WhoPayment';

export default {
  layout: function layout(context) {
    if (process.server) {
      if (context.route.query.test) {
        console.log('Theme: ' + global.getTheme() + '  -  "' + global.hostname + '"');
      }
    }
    console.log(global.getTheme());
    return global.getTheme();
  },

  components: {
    SearchBox: SearchBox, LoadingData: LoadingData, Testimonial: Testimonial, WhoTestimonial: WhoTestimonial, WhoPayment: WhoPayment, WhoApp: WhoApp
  },
  data: function data() {
    return {
      loading: false,
      searchText: '',
      type: 'name',
      view: 'default'
    };
  },
  created: function created() {
    this.view = global.getTheme();

    // let cookieOptions = {path: '/'}
    //
    // document.cookie = cookie.serialize('utm_price_new_design_exp', priceNewDesignExp, cookieOptions) + '; ' + document.cookie;
    //
    // let parsedCookies = cookie.parse(document.cookie);
    // let doExp = 'K';
    //
    // document.cookie = cookie.serialize('utm_abexperement', doExp, cookieOptions) + '; ' + document.cookie;
    // parsedCookies = cookie.parse(document.cookie);
    // global.resetAxiosHeaders();
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    },

    websiteName: function websiteName() {
      var displayName = global.websiteSettings.extra_info.display_name;
      if (displayName) {
        return this.$root.trans('st_public.' + displayName);
      }
      return '';
    }
  },
  methods: {
    startLoading: function startLoading(flag, searchText) {
      this.loading = flag;
      this.searchText = searchText;
    },
    stopLoading: function stopLoading(flag) {
      this.loading = flag;
    },
    hardCodedBG: function hardCodedBG() {
      if (process.client) {
        if (window.location.hostname.match(/hawiyyah/i)) {
          return true;
        }
      }
      return false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/flow---Mg==.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/flow---Mg==.vue
// module chunks = 3